import { createAction } from '@reduxjs/toolkit';

export const addProduct = createAction('recentlyviewed/add_product');
